import { useContext } from 'react';
import { StoreGlobalContext } from 'src/context/GlobalStateContext';

const useStoreGlobal = () => {
  const context = useContext(StoreGlobalContext);
  return context;
};

export default useStoreGlobal;
